module.exports = __webpack_public_path__ + "img/85_titanic.82b1ca60.jpg";